import { useTransformPlaybookContext } from 'app/context/transform-playbook-context';
import buildEditorRevisionMeta from './buildEditorRevisionMeta';
import useParsedInput from './useParsedInput';
import usePipelineSelection from './usePipelineSelection';
import useSelectedPipelineData from './useSelectedPipelineData';
import useTestPlaybookChainState from './useTestPlaybookChainState';
import useResetChainOnInputChange from './useResetChainOnInputChange';
import buildDrawerActions from './buildDrawerActions';
import buildDrawerContextValue from './buildDrawerContextValue';

// Wires the drawer's state (parsed input, pipeline selection + data, the
// 4-stage chain) and returns the context value. Mode state is owned by
// TransformDrawer so it survives drawer close/reopen within the page.
export default function useTestPlaybookDrawer({ integration, playbookState, mode, setMode }) {
  const { input, clusterId, hasValidInput, playbook, setClusterId } = useTransformPlaybookContext();

  const revisionMeta = buildEditorRevisionMeta({ integration, playbookState });
  const { parsedInput } = useParsedInput(input);
  const pipelineSelection = usePipelineSelection({ clusterId });
  const pipelineData = useSelectedPipelineData({ integrationId: integration.id, clusterId });
  const pipelineSelected = Boolean(pipelineSelection.selectedPipelineId);

  const chainState = useTestPlaybookChainState({
    mode,
    parsedInput,
    hasValidInput,
    clusterId,
    editorPlaybook: playbook,
    connectionJson: playbookState.connectionJSON,
    integration,
    revisionMeta,
    pipelineSelected,
    deployedPipeline: pipelineData.deployedPipeline,
    attachment: pipelineData.attachment,
    pipelineDataLoading: pipelineSelected && !pipelineData.ready,
  });

  useResetChainOnInputChange({ input, resetChain: chainState.resetChain });

  const actions = buildDrawerActions({ setMode, setClusterId, pipelineSelection, pipelineData, chainState });

  return buildDrawerContextValue({
    mode,
    actions,
    integration,
    revisionMeta,
    pipelineData,
    pipelineSelection,
    chainState,
  });
}
